import React from "react";
import { FaPencilAlt, FaTrash } from "react-icons/fa";
import { useLocation } from "react-router-dom";

interface ActionButtonsProps {
  onEdit?: () => void;
  onDelete: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({ onEdit, onDelete }) => {
  const location = useLocation();
  const role = localStorage.getItem("role");
  const disableButtons = role === "user" && location.pathname === "/admin/users";
  return (
    <td className="px-4 py-2 text-right">
      <div className="flex gap-x-4 ml-auto justify-end">
        <button
          onClick={onEdit}
          className={`bg-brand-500 text-white px-3 py-2 rounded-md hover:bg-brand-600 transition-colors ${
            disableButtons ? "opacity-50 cursor-not-allowed" : ""
          }`}
          disabled={disableButtons}
        >
          <FaPencilAlt size={16} />
        </button>
        <button
          onClick={onDelete}
          className={`bg-red-600 text-white px-3 py-2 rounded-md mr-4 hover:bg-red-700 ${
            disableButtons ? "opacity-50 cursor-not-allowed" : ""
          }`}
          disabled={disableButtons}
        >
          <FaTrash size={16} />
        </button>
      </div>
    </td>
  );
};

export default ActionButtons;

